/*  ========================================================================
    # Scripts - Hero with Parallax
    ========================================================================  */

/**
 *
 */

const HeroWithParallax = {
  cfg: {
    body: document.querySelector('body'),
    scrolled: false,
    container: document.querySelector('.s-hero-with-parallax'),
    beforeWrapper: document.querySelector('.s-hero-with-parallax__before-wrapper'),
    image: {
      before: document.querySelector('.s-hero-with-parallax__image--before'),
      after: document.querySelector('.s-hero-with-parallax__image--after')
    }
  },

  /**
   *
   */
  setAfterImageHeight() {
    this.cfg.image.before.style.height = `${this.cfg.container.offsetHeight}px`;

    window.addEventListener('resize', () => {
      this.cfg.image.before.style.height = `${this.cfg.container.offsetHeight}px`;
    });
  },

  /**
   *
   */
  scrollHandler() {
    if (window.scrollY === 0) {
      this.cfg.body.style.overflow = 'hidden';
    } else {
      this.cfg.scrolled = true;
      this.cfg.beforeWrapper.style.height = '0%';
    }

    window.addEventListener('wheel', event => {
      const scrollDirection = event.wheelDelta > 0 ? 'up' : 'down';

      if (scrollDirection === 'up' && window.scrollY === 0 && this.cfg.scrolled === true) {
        this.cfg.body.style.overflow = 'hidden';
        this.cfg.beforeWrapper.style.height = '100%';

        setTimeout(() => {
          this.cfg.scrolled = false;
        }, 2000);
      } else if (scrollDirection === 'down' && this.cfg.scrolled === false) {
        this.cfg.beforeWrapper.style.height = '0%';

        setTimeout(() => {
          this.cfg.scrolled = true;
          this.cfg.body.style.overflow = '';
        }, 2000);
      }
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (typeof this.cfg.container !== undefined && this.cfg.container !== null) {
      this.setAfterImageHeight();
      if (window.innerWidth >= 768) {
        this.scrollHandler();
      }

      window.addEventListener('resize', () => {
        if (window.innerWidth >= 768) {
          this.scrollHandler();
        } else {
          this.cfg.body.style.overflow = '';
        }
      });
    }
  }
};

export default HeroWithParallax;
